import React from 'react'

const StandingsHeader = ({numberOfFish = 0, hideFish = false, showDays = false, days = 0, day, tourney_type, day_array, hide_fish_records }) => {

  const getFishHeaders = (numberOfFish) => {
    
    /*
    console.log('numberOfFish values set::',numberOfFish );
    console.log('day value passed:::',day);
    console.log('showDays value:::', showDays);
    console.log('tourney_type value passed:::', tourney_type);
    console.log('day_array value passed:::', day_array);
    */
   
    if(!numberOfFish) return <></>

    let fishHeaders = [];
    for (let i = 0; i < numberOfFish; i++) {

      if(hide_fish_records && hide_fish_records == '1'){
        if(numberOfFish > 5) {
          fishHeaders.push(<th style={{whiteSpace: 'nowrap',opacity:'0'}} key={`${day}header${i}`}>F{i+1}</th>)
        }else{
          fishHeaders.push(<th style={{whiteSpace: 'nowrap',opacity:'0'}} key={`${day}header${i}`}>Fish {i+1}</th>)
        }
      }else{
        if(numberOfFish > 5) {
          fishHeaders.push(<th style={{whiteSpace: 'nowrap'}} key={`${day}header${i}`}>F{i+1}</th>)
        }else{
          fishHeaders.push(<th style={{whiteSpace: 'nowrap'}} key={`${day}header${i}`}>Fish {i+1}</th>)
        }
      }

      
    }

    // console.log(`fish headers = ${fishHeaders.length}`)
    return fishHeaders
  }
  
  //console.log('Days value passed for header::', days);

  const getDayHeaders = (days) => [...Array(parseInt(days))].map((_, index) => <th key={index}>Day {index + 1}</th> )

  // Show day and date headers for multi-single type tournament ( Type  - 12 )
  // Change added on 03-29-2021

  const getMultiSingDayHeaders = (day_array) => {

    let dayWiseFishHeaders = [];

    day_array.map((date,index) => (
      dayWiseFishHeaders.push( <th key={index+1} > {date.toLocaleDateString("en-US",{weekday: "short"})} {`-`} { date.toLocaleDateString("en-US",{day: "2-digit"}) }   </th>)
    ))

    return dayWiseFishHeaders
  }

  const fishHeaders = getFishHeaders(numberOfFish)

  const header = hideFish 
    ? <thead className="standings-header">
        <tr className="standings-fish-header">
          <th>Rk</th>
          <th className="standings-angler">Angler</th>
          
          <th>Total</th>
        </tr>
      </thead>
    : <thead className="standings-header">
        <tr className="standings-fish-header">
          <th>Rk</th>
          <th className="standings-angler left">Angler</th>
           
          { 
            ( tourney_type &&  tourney_type == 12 ) ?

            showDays 
              ? getMultiSingDayHeaders(day_array)
              : fishHeaders
            :
            showDays 
            ? getDayHeaders(days)
            : fishHeaders

             
          }

          <th>Total</th>
        </tr>
      </thead>

  return ( 
  <>
    {header}
  </> 
  )
}

export default StandingsHeader